import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.jsx'
import './index.css'

// Widget persistence helper
window.addEventListener('spa-navigation', function() {
  // Give the widget a chance to reinitialize after route changes
  setTimeout(() => {
    const event = new CustomEvent('widget-reinit')
    window.dispatchEvent(event)
  }, 100)
})

// Minimal CSS for widget
const widgetCSS = `
[id*="talkida-widget"], [class*="talkida-widget"] {
  z-index: 999999 !important;
}
`
const style = document.createElement('style')
style.textContent = widgetCSS
document.head.appendChild(style)

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
